import GearSolid from './GearSolid'

export default GearSolid
// eslint-disable-next-line import/export
export * from './GearSolid'
